import type { PackageDirectionType } from '../enums/PackageDirectionType'
import type { PackageItemType } from '../enums/PackageItemType'
import type { PackageStatus } from '../enums/PackageStatus'
import type { AssignedDriverEntity } from '@/features/livePackage/domain/entities/LivePackageEntity'
import type { OrderPaymentType } from '@/features/order/domain/enums/OrderPaymentType'
import type { VehicleTemplateType } from '@/features/vehicleTemplate/domain/enums/VehicleTemplateType'

export class PackageMiniEntity {
  id?: string
  user?: {
    id?: string
    displayName?: string | null
    phoneNumber?: string | null
  }
  serviceId?: number
  serviceName?: string | null
  status?: PackageStatus
  statusUpdatedAt?: string
  deliveryFeePrice?: number
  invoice?: {
    deliveryFee?: number
    serviceFee?: number
    total?: number
    paymentType?: OrderPaymentType
  }
  trackingPanelUserDisplayName?: string | null
  trackingPanelUserId?: string | null
  senderName?: string | null
  senderPhoneNumber?: string | null
  receiverName?: string | null
  receiverPhoneNumber?: string | null
  directionType?: PackageDirectionType
  vehicleTemplateType?: VehicleTemplateType | null
  itemType?: PackageItemType
  referenceCode?: string | null
  createdAt?: string
  assignedDriver?: AssignedDriverEntity;

}
